export const formatDiscount = (discountId) => {
    if (!discountId) return "No Discount";
    switch (discountId) {
        case "p1mtier1discount":
            return "1 Month (29.99₺ - 1.99$ - 1.99€ - 0.99£ - 2.99CAD)";
        case "p1mtier2discount":
            return "1 Month (49.99₺ - 2.99$ - 2.99€ - 1.99£ - 3.99CAD)";
        case "p1mtier3discount":
            return "1 Month (79.99₺ - 3.99$ - 3.99€ - 2.99£ - 4.99CAD)";
        case "p6mtier1discount":
            return "6 Month (149.99₺ - 7.99$ - 7.99€ - 6.99£ - 9.99CAD)";
        case "p6mtier2discount":
            return "6 Month (249.99₺ - 9.99$ - 9.99€ - 8.99£ - 12.99CAD)";
        case "p6mtier3discount":
            return "6 Month (299.99₺ - 14.99$ - 14.99€ - 12.99£ - 19.99CAD)";
        case "p6mtier4discount":
            return "6 Month (349.99₺ - 17.99$ - 17.99€ - 14.99£ - 24.99CAD)";
        case "p6mtier6discount":
            return "6 Month (399.99₺ - 17.99$ - 17.99€ - 14.99£ - 24.99CAD)";
        case "p1ytier1discount":
            return "1 Year (299.99₺ - 14.99$ - 14.99€ - 12.99£ - 19.99CAD)";
        case "p1ytier2discount":
            return "1 Year (349.99₺ - 17.99$ - 17.99€ - 14.99£ - 24.99CAD)";
        case "p1ytier3discount":
            return "1 Year (399.99₺ - 19.99$ - 19.99€ - 17.99£ - 29.99CAD)";
        case "p1ytier4discount":
            return "1 Year (499.99₺ - 24.99$ - 24.99€ - 19.99£ - 34.99CAD)";
        default:
            return "No Discount";
    }
}